import { type CaptureFileJSONObject, type IkeActionCaptureImageMetadata, IkeRequestHeader } from '@ikegps/core-api';
import type { IkeRestDepartment } from './rest.department';

export class IkeRestDepartmentImage {
	boundDepartment: IkeRestDepartment;

	constructor(boundDepartment: IkeRestDepartment) {
		this.boundDepartment = boundDepartment;
	}

	async capture(
		imageData: Uint8Array<ArrayBuffer> | string,
		metadata: IkeActionCaptureImageMetadata
	): Promise<CaptureFileJSONObject> {
		const core = this.boundDepartment.boundUser.core;
		const headers = core.headers(this.boundDepartment.boundUser.accessToken, this.boundDepartment.departmentId);

		headers[IkeRequestHeader.CONTENT_TYPE] = 'image/jpeg';
		headers[IkeRequestHeader.REQUEST_ARGS] = JSON.stringify(metadata);

		const response = await core.fetch(core.path(`/v1/action/capture.image.create`), {
			method: 'POST',
			body: imageData,
			headers,
		});

		if (response.ok) {
			await core.validateIsJson(response);
			return response.json();
		}
		return core.handleError(response);
	}

	async image(
		uuid: string,
		imageData: Uint8Array<ArrayBuffer> | string,
		zoom: number,
		collectedAt: Date
	): Promise<CaptureFileJSONObject> {
		return this.capture(imageData, {
			type: 'image',
			zoom,
			collectedAt: collectedAt.toISOString(),
			uuid,
			metadata: undefined,
		});
	}
}
